import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    downloading: string;
    uploading: string;
    checksumming: string;
    loadingAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label when downloading */
            downloading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ChecksumsProgressJobStatus.downloading?c=3r25jbvao6oon", defaultMessage: "Downloading" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when uploading */
            uploading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ChecksumsProgressJobStatus.uploading?c=r9sxgdwjdzde", defaultMessage: "Uploading" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when generating checksums */
            checksumming: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ChecksumsProgressJobStatus.checksumming?c=3ji5radad38sr", defaultMessage: "Checksumming" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for loading spinner */
            loadingAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ChecksumsProgressJobStatus.loadingAriaLabel?c=57512ik3sq66", defaultMessage: "Loading" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
